import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Container, Row, Col, Form, Card, Button, Table, Pagination, Badge,
} from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Breadcrumb } from "react-bootstrap";
import {
  createAuthoritiesPath,
  getAllAuthoritiesPaths,
  updateAuthoritiesPath,
  getAuthorities,
  getAllEmployees,
  getAllDepartments,
} from "../../../../api/onboarddeboard";

const AuthoritiesPath = () => {
  const token = localStorage.getItem("token");

  const [seqNo, setSeqNo] = useState("");
  const [authorityId, setAuthorityId] = useState("");
  const [authorities, setAuthorities] = useState([]);
  const [selectionType, setSelectionType] = useState("DEPARTMENT");
  const [departmentId, setDepartmentId] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [active, setActive] = useState(true);

  const [departments, setDepartments] = useState([]);
  const [employees, setEmployees] = useState([]);

  const [authPaths, setAuthPaths] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [errors, setErrors] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [sortField, setSortField] = useState("seqNo");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchTerm), 400);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const fetchAuthPaths = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await getAllAuthoritiesPaths(token);
      setAuthPaths(res.data || []);
    } catch {
      toast.error("Error loading authorities paths.");
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (token) fetchAuthPaths();
  }, [token, fetchAuthPaths]);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const res = await getAllDepartments(token);
        setDepartments(res.data || []);
      } catch {
        toast.error("Error loading departments.");
      }
    };
    if (token) fetchDepartments();
  }, [token]);

  useEffect(() => {
    const fetchAuthorities = async () => {
      try {
        const res = await getAuthorities(token);
        const activeOnly = (res.data || []).filter((a) => a.status === true);
        console.log("Authority sample:", activeOnly[0]);
        setAuthorities(activeOnly);
      } catch {
        toast.error("Error loading authorities.");
      }
    };
    if (token) fetchAuthorities();
  }, [token]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const res = await getAllEmployees(token);
        const staffUsers = (res.data || []).filter(
          (emp) => emp.name && emp.name.trim() !== "",
        );
        setEmployees(staffUsers);
      } catch {
        toast.error("Error loading employees.");
      }
    };
    if (token) fetchEmployees();
  }, [token]);

  useEffect(() => {
    let filtered = [...authPaths];

    if (debouncedSearch.trim()) {
      filtered = filtered.filter(
        (item) =>
          item.authority?.authorityName
            ?.toLowerCase()
            .includes(debouncedSearch.toLowerCase()) ||
          String(item.seqNo).includes(debouncedSearch),
      );
    }

    if (statusFilter !== "ALL") {
      const isActive = statusFilter === "ACTIVE";
      filtered = filtered.filter((item) => item.status === isActive);
    }

    if (sortField === "seqNo") {
      filtered.sort((a, b) => Number(a.seqNo) - Number(b.seqNo));
    } else if (sortField === "name") {
      filtered.sort((a, b) =>
        (a.authority?.authorityName || "").localeCompare(b.authority?.authorityName || ""),
      );
    } else if (sortField === "status") {
      filtered.sort((a, b) => {
        if (a.status === b.status) return Number(a.seqNo) - Number(b.seqNo);
        return a.status ? -1 : 1;
      });
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [authPaths, debouncedSearch, statusFilter, sortField]);
  const getSeqNoError = (value) => {
    const val = String(value);

    if (val.length === 0) {
      return "Sequence No is required.";
    }
    if (/^\s+$/.test(val)) {
      return "Sequence No cannot be only spaces.";
    }
    if (/^[a-zA-Z]+$/.test(val)) {
      return "Sequence No cannot be alphabets.";
    }
    if (/^[^a-zA-Z0-9\s]+$/.test(val)) {
      return "Sequence No cannot be special characters.";
    }
    if (!/^\d+$/.test(val)) {
      return "Letters and special characters are not allowed. Only numbers allowed.";
    }
    if (Number(val) < 1) {
      return "Sequence No must be at least 1.";
    }
    return "";
  };
  const handleSeqNo = (e) => {
  const value = e.target.value;
  setSeqNo(value);

  setErrors((prev) => ({
    ...prev,
    seqNo: value === "" ? "" : getSeqNoError(value),
  }));
};
  const handleSubmit = async () => {
    let formValid = true;
    const newErrors = {};

    if (!authorityId) {
      newErrors.authorityId = "Please select an Authority Name.";
      formValid = false;
    }
  // Check if the selected employee is the same as the selected authority
    let isSelfAuthority = false;
    if (selectionType === "EMPLOYEE" && employeeId && authorityId) {
      const selectedAuthority = authorities.find(
        (a) => Number(a.authorityId) === Number(authorityId)
      );
      if (selectedAuthority && Number(selectedAuthority.user?.id) === Number(employeeId)) {
        formValid = false;
        isSelfAuthority = true;
        toast.error("Employee cannot be assigned as their own approval authority.");
      }
    }


const duplicateAuthorityPath = authPaths.find((p) => {
  if (p.id === editId) return false;
  if (selectionType === "DEPARTMENT" && p.selectionType === "DEPARTMENT") {
    return (
      Number(p.department?.id) === Number(departmentId) &&
      Number(p.authority?.authorityId) === Number(authorityId)
    );
  }
  if (selectionType === "EMPLOYEE" && p.selectionType === "EMPLOYEE") {
    const existingEmpId = p.employee?.userInfoId ?? p.employee?.id;
    return (
      Number(existingEmpId) === Number(employeeId) &&
      Number(p.authority?.authorityId) === Number(authorityId)
    );
  }
  return false;
});
    if (duplicateAuthorityPath && !isSelfAuthority) {
  formValid = false;
  if (selectionType === "DEPARTMENT") {
    toast.error("Department with this Authority Name already exists.");
  } else {
    toast.error("Employee already has an authority assigned.");
  }
} else {
      const seqNoError = getSeqNoError(seqNo);
      if (seqNoError) {
        newErrors.seqNo = seqNoError;
        formValid = false;
      } else {
       const duplicateSeq = authPaths.find((p) => {
  if (seqNo === "" || p.id === editId) return false;
  if (p.selectionType !== selectionType) return false;
  if (Number(p.seqNo) !== Number(seqNo)) return false;
  if (selectionType === "DEPARTMENT") {
    return Number(p.department?.id) === Number(departmentId);
  }
  const existingEmpId = p.employee?.userInfoId ?? p.employee?.id;
  return Number(existingEmpId) === Number(employeeId); 
});
        if (duplicateSeq) {
          newErrors.seqNo = "Sequence No already exists.";
          formValid = false;
        }
      }
    }

    if (selectionType === "DEPARTMENT" && !departmentId) {
      newErrors.departmentId = "Please select a Department.";
      formValid = false;
    }
    if (selectionType === "EMPLOYEE" && !employeeId) {
      newErrors.employeeId = "Please select an Employee.";
      formValid = false;
    }

    setErrors(newErrors);
    if (!formValid) return;

    const payload = {
      seqNo: Number(seqNo),
      selectionType,
      status: active,
    };

    const authIdParam = Number(authorityId);
    const deptIdParam = selectionType === "DEPARTMENT" ? Number(departmentId) : null;
    const empIdParam = selectionType === "EMPLOYEE" ? Number(employeeId) : null;

    try {
      if (isEditing) {
        await updateAuthoritiesPath(editId, authIdParam, deptIdParam, empIdParam, payload, token);
        toast.success("Authorities Path updated successfully");
      } else {
        await createAuthoritiesPath(authIdParam, deptIdParam, empIdParam, payload, token);
        toast.success("Authorities Path created successfully");
      }
      resetForm();
      fetchAuthPaths();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error occurred");
    }
  };

 const handleEdit = (item) => {
    setErrors({});
    setSeqNo(String(item.seqNo || ""));
    setAuthorityId(item.authority?.authorityId || "");
    setSelectionType(item.selectionType || "DEPARTMENT");
    setDepartmentId(item.department?.id || "");
    setEmployeeId(item.employee?.id || "");
    setActive(item.status ?? true);
    setEditId(item.id);
    setIsEditing(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => {
    setSeqNo("");
    setAuthorityId("");
    setSelectionType("DEPARTMENT");
    setDepartmentId("");
    setEmployeeId("");
    setActive(true);
    setIsEditing(false);
    setEditId(null);
    setErrors({});
  };

  const paginated = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const filteredAuthorities = useMemo(() => {
    return authorities.filter((auth) => auth.status === true);
  }, [authorities]);

  const handleExportCSV = () => {
    const headers = ["Seq No", "Authority Name", "Selection Type", "Department / Employee", "Status"];
    const rows = filteredData.map((item) => [
      item.seqNo,
      item.authority?.authorityName || "",
      item.selectionType || "",
      item.selectionType === "DEPARTMENT"
        ? item.department?.departmentName || ""
        : item.employee?.name || "",
      item.status ? "Active" : "Inactive",
    ]);

    let csv = headers.join(",") + "\n";
    rows.forEach((row) => { csv += row.map((cell) => `"${cell}"`).join(",") + "\n"; });

    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `authorities-path-${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <Container fluid className="p-4">
      <style>{`
        .leave-toggle .form-check-input:checked {
          background-color: #2E5CB8 !important;
          border-color: #2E5CB8 !important;
        }
        .leave-toggle .form-check-input:focus {
          border-color: #2E5CB8 !important;
          box-shadow: 0 0 0 0.1rem rgba(46, 92, 184, 0.35) !important;
        }
        .leave-toggle .form-check-label {
          white-space: nowrap;
        }
        .col-form-label {
          white-space: nowrap;
        }
        .lc-breadcrumb a { text-decoration: none !important; color: #2E5CB8 !important; }
        .lc-breadcrumb .breadcrumb-item.active { color: #6c757d !important; }
        .pagination .page-item.active .page-link {
          background-color: #2E5CB8 !important;
          border-color: #2E5CB8 !important;
        }

        
        @media (max-width: 991.98px) {
          .p-4 { padding: 1rem !important; }
        }

        @media (max-width: 767.98px) {
          h4[style] { font-size: 22px !important; }
        }

  
        @media (max-width: 767.98px) {
          .authpath-filters-row {
            flex-wrap: wrap !important;
            row-gap: 8px;
          }
          .authpath-filters-row > div {
            width: 100% !important;
          }
          .authpath-filters-row input,
          .authpath-filters-row select {
            width: 100% !important;
          }
        }

        
        @media (max-width: 575.98px) {
          .table-responsive table {
            font-size: 13px;
          }
        }
        @media (max-width: 575.98px) {
          .authpath-form-actions {
            flex-wrap: wrap;
          }
          .authpath-form-actions button {
            width: 100%;
            margin-left: 0 !important;
            margin-top: 8px;
          }
          .authpath-form-actions button:first-child {
            margin-top: 0;
          }
        }
      `}</style>
      <h4
        className="page-main-heading"
        style={{ marginBottom: 12 }}
      >
        Authorities Path
      </h4>
      <Breadcrumb className="lc-breadcrumb">
        <Breadcrumb.Item href="#">
          Leave
        </Breadcrumb.Item>

        <Breadcrumb.Item href="#">
          Shift & Authorities
        </Breadcrumb.Item>

        <Breadcrumb.Item active>
          Authorities Path
        </Breadcrumb.Item>
      </Breadcrumb>

      <Row className="mb-4">
        <Col xl={12}>
          <Card>
            <Card.Body>
              <Form>
                <Row>
                  <Col>
                    <Row className="mb-3">
                      <Form.Label className="col-sm-4 col-form-label form-label">
                        Selection Type<span className="text-danger">*</span>
                      </Form.Label>
                      <Col sm={8}>
                        <Row className="mt-2">
                          <Col>
                            <div className="leave-toggle">
                              <Form.Check
                                type="switch"
                                id="typeDept"
                                label="Department Wise"
                                checked={selectionType === "DEPARTMENT"}
                                onChange={() => {
                                  setSelectionType("DEPARTMENT");
                                  setEmployeeId("");
                                  setErrors((prev) => ({ ...prev, departmentId: "", employeeId: "" }));
                                }}
                              />
                            </div>
                          </Col>
                          <Col>
                            <div className="leave-toggle">
                              <Form.Check
                                type="switch"
                                id="typeEmp"
                                label="Employee Wise"
                                checked={selectionType === "EMPLOYEE"}
                                onChange={() => {
                                  setSelectionType("EMPLOYEE");
                                  setDepartmentId("");
                                  setErrors((prev) => ({ ...prev, departmentId: "", employeeId: "" }));
                                }}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    {selectionType === "DEPARTMENT" && (
                      <Row className="mb-3">
                        <Form.Label className="col-sm-4 col-form-label form-label">
                          Department<span className="text-danger">*</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            value={departmentId}
                            onChange={(e) => {
                              setDepartmentId(e.target.value);
                              setErrors((prev) => ({ ...prev, departmentId: "" }));
                            }}
                          >
                            <option value=""> Select Department </option>
                            {departments.map((dept) => (
                              <option key={dept.id} value={dept.id}>{dept.departmentName}</option>
                            ))}
                          </Form.Select>
                          {errors.departmentId && (
                            <p style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>{errors.departmentId}</p>
                          )}
                        </Col>
                      </Row>
                    )}

                    {selectionType === "EMPLOYEE" && (
                      <Row className="mb-3">
                        <Form.Label className="col-sm-4 col-form-label form-label">
                          Employee<span className="text-danger">*</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            value={employeeId}
                            onChange={(e) => {
                              setEmployeeId(e.target.value);
                              setErrors((prev) => ({ ...prev, employeeId: "" }));
                            }}
                          >
                            <option value="">Select Employee </option>
                            {employees.map((emp) => (
                              <option key={emp.userInfoId} value={emp.userInfoId}>{emp.name}</option>
                            ))}
                          </Form.Select>
                          {errors.employeeId && (
                            <p style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>{errors.employeeId}</p>
                          )}
                        </Col>
                      </Row>
                    )}
                    <Row className="mb-3">
                      <Form.Label className="col-sm-4 col-form-label form-label">Active</Form.Label>
                      <Col className="mt-2">
                        <div className="leave-toggle">
                          <Form.Check
                            type="switch"
                            id="active"
                            label="Check If Active"
                            checked={active}
                            onChange={(e) => setActive(e.target.checked)}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col>
                    <Row className="mb-3">
                      <Form.Label className="col-sm-3 col-form-label form-label">
                        Sequence No<span className="text-danger">*</span>
                      </Form.Label>
                      <Col sm={9}>
                        <Form.Control
                          type="text"
                          placeholder="Enter Sequence No"
                          value={seqNo}
                          onChange={handleSeqNo}
                        />
                        {errors.seqNo && (
                          <p style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>{errors.seqNo}</p>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Form.Label className="col-sm-3 col-form-label form-label">
                        Authority Name<span className="text-danger">*</span>
                      </Form.Label>
                      <Col sm={9}>
                        <Form.Select
                          value={authorityId}
                          onChange={(e) => {
                            setAuthorityId(e.target.value);
                            setErrors((prev) => ({ ...prev, authorityId: "" }));
                          }}
                        >
                          <option value="">Select Authority Name </option>
                          {filteredAuthorities.map((auth) => (
                            <option key={auth.authorityId} value={auth.authorityId}>{auth.authorityName}</option>
                          ))}
                        </Form.Select>
                        {errors.authorityId && (
                          <p style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>{errors.authorityId}</p>
                        )}
                      </Col>
                    </Row>
                  </Col>

                  <Row className="align-items-center">
                    <Col className="mt-4 d-flex align-items-center justify-content-center authpath-form-actions">
                      <Button
                        variant="primary"
                        type="button"
                        onClick={handleSubmit}
                        style={{ backgroundColor: "#2E5CB8", borderColor: "#2E5CB8" }}
                      >
                        {isEditing ? "Update" : "Submit"}
                      </Button>
                      <Button variant="secondary" style={{ marginLeft: "10px" }} onClick={resetForm}>
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col xl={12}>
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Authorities Path List</h5>
              <Button variant="outline-primary" size="sm" onClick={handleExportCSV}>
                <i className="bi bi-download me-2"></i>Export CSV
              </Button>
            </Card.Header>

            <Card.Body>
              <Row className="mb-3 justify-content-end align-items-center authpath-filters-row">
                <Col xs="auto">
                  <Form.Control
                    type="text"
                    placeholder="Search by Name or Seq No..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "260px", fontSize: "14px", height: "32px", padding: "4px 10px" }}
                  />
                </Col>
                <Col xs="auto">
                  <Form.Select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    style={{ width: "130px", fontSize: "14px", height: "32px", padding: "4px 10px" }}
                  >
                    <option value="ALL">All Status</option>
                    <option value="ACTIVE">Active</option>
                    <option value="INACTIVE">Inactive</option>
                  </Form.Select>
                </Col>
                <Col xs="auto">
                  <Form.Select
                    value={sortField}
                    onChange={(e) => setSortField(e.target.value)}
                    style={{ width: "150px", fontSize: "14px", height: "32px", padding: "4px 10px" }}
                  >
                    <option value="seqNo">Sort: Seq No (Asc)</option>
                    <option value="name">Sort: Name (A-Z)</option>
                    <option value="status">Sort: Status</option>
                  </Form.Select>
                </Col>
                <Col xs="auto">
                  <Badge bg="secondary">Total: {filteredData.length}</Badge>
                </Col>
              </Row>

              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    {["Sr.No", "Seq No", "Authority Name", "Selection Type", "Department / Employee", "Status", "Action"].map((h) => (
                      <th key={h} style={{ backgroundColor: "#2E5CB8", color: "white" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="7" className="text-center py-4">
                        <div className="text-muted">
                          <i className="bi bi-hourglass-split fs-3 d-block mb-2"></i>Loading...
                        </div>
                      </td>
                    </tr>
                  ) : paginated.length > 0 ? (
                    paginated.map((item, i) => (
                      <tr key={item.id}>
                        <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                        <td>{item.seqNo}</td>
                        <td>{item.authority?.authorityName || "-"}</td>
                        <td>{item.selectionType === "DEPARTMENT" ? "Department Wise" : "Employee Wise"}</td>
                        <td>
                          {item.selectionType === "DEPARTMENT"
                            ? item.department?.departmentName || "-"
                            : item.employee?.name || "-"}
                        </td>
                        <td>{item.status ? "Active" : "Inactive"}</td>
                        <td>
                          <Button
                            className="btn btn-secondary"
                            onClick={() => handleEdit(item)}
                            type="button"
                            style={{ padding: "3px 8px", fontSize: "12px" }}
                          >
                            <i className="bi bi-pencil-fill me-1" /> Edit
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center py-4">
                        <div className="text-muted">
                          <i className="bi bi-inbox fs-3 d-block mb-2"></i>No authorities paths found
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {totalPages > 1 && (
                <div className="d-flex justify-content-end">
                  <Pagination>
                    <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1} />
                    {[...Array(totalPages).keys()].map((n) => (
                      <Pagination.Item key={n} active={n + 1 === currentPage} onClick={() => setCurrentPage(n + 1)}>
                        {n + 1}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages} />
                  </Pagination>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <ToastContainer position="top-right" autoClose={3000} />
    </Container>
  );
};

export default AuthoritiesPath;
